<template>
  <div
    class="legendModal"
    @click="closeModal"
  >
    <div class="inner">
      <button
        class="close"
      />
      <div
        class="card"
        @click.stop
      >
        <div
          v-for="item in listExplain"
          :key="item.imgKey"
          class="legend"
        >
          <p class="title">
            {{ item.title }}
          </p>
          <ul class="content">
            <li
              v-for="content in item.content"
              :key="content.imgRank"
              class="list"
            >
              <div class="image">
                <figure>
                  <img
                    :src="`${runtimeConfig.public.gvsUrl}/onebox/img/${item.imgKey}${content.imgRank}.svg`"
                    alt=""
                    width="30"
                    height="30"
                  >
                </figure>
              </div>
              <div class="textarea">
                <p class="name">
                  {{ content.title }}
                </p>
                <p
                  v-if="content.text"
                  class="text"
                >
                  {{ content.text }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const runtimeConfig = useRuntimeConfig()

const listExplain = [
  {
    title: '服装指数',
    imgKey: 'world/icon/tops_',
    content: [
      { imgRank: '11', title: 'ノースリーブ', text: 'ノースリーブ1枚でも過ごせる暑さです。' },
      { imgRank: '10', title: 'Tシャツ1枚', text: 'Tシャツ1枚でも過ごせる暑さです。' },
      { imgRank: '09', title: '半袖シャツ1枚', text: '厚手の半袖Tシャツや襟付きの半袖シャツ1枚くらいがちょうどいい暑さです。' },
      { imgRank: '08', title: '長袖シャツ1枚', text: '長袖シャツ1枚くらいで快適に過ごせそうです。' },
      { imgRank: '07', title: 'カーディガン', text: '長袖Tシャツなどの上に、薄手の羽織るものがあると快適に過ごせそうです。' },
      { imgRank: '06', title: '薄手セーター', text: '長袖Tシャツなどシャツの上に薄手のセーター1枚重ねるくらいで快適に過ごせそうです。' },
      { imgRank: '05', title: '厚手セーター（厚手スウェット）', text: '長袖Tシャツなどシャツの上に厚手のセーターやスウェットなど、熱を逃しにくいものを重ねるなど暖かな服装がちょうど良さそうです。薄手のニットに軽いジャケット羽織るのもおすすめです。' },
      { imgRank: '04', title: '薄手コート', text: '春秋向けのやや薄手のアウターやジャケットなどの上着があるとちょうど良く過ごせそうです。' },
      { imgRank: '03', title: '厚手コート', text: '裏地のあるしっかりとした冬物の厚手コートがあると暖かに過ごせそうです。風が冷たい日はさらに、手袋や帽子など防寒対策があると安心です。' },
      { imgRank: '02', title: 'ダウンコート', text: 'ダウンコートなど風や冷気を通さず、保温効果が高いアウターが重宝する寒さです。必要に応じて手袋やニット帽で防寒すると良さそうです。' },
      { imgRank: '01', title: 'ダウンコート＋防寒小物', text: 'ダウンコートなど風や冷気を通さず、保温効果が高いアウターが重宝する寒さです。さらに、手袋やニット帽など防寒対策が必須です。' }
    ]
  },
  {
    title: '傘指数',
    imgKey: 'common/icon_prec_',
    content: [
      { imgRank: '04', title: '傘必須', text: '降水確率が90%以上で傘が必須です。' },
      { imgRank: '03', title: '長傘', text: '降水確率が70%以上と高く、長傘が必要です。' },
      { imgRank: '02', title: '折り畳み傘', text: '降水確率が20%以上と雨の可能性があるため、折り畳み傘が必要です。' },
      { imgRank: '01', title: '必要なし', text: '降水確率が20%未満で雨の可能性は低いので、傘は必要ありません。' }
    ]
  }
]

const emit = defineEmits(['close-modal'])
const closeModal = () => {
  emit('close-modal')
}
</script>

<style lang="scss" scoped>
.legendModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / .33);
  z-index: 100;
  .inner {
    position: relative;
    width: 100%;
    height: 100vh;
    max-width: min(90%, 660px);
    margin-inline: auto;
    padding: 40px 0;
  }
  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 15px;
    right: 0;
    cursor: pointer;
    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 24px;
      height: 3px;
      border-radius: 100vmax;
      background-color: #fff;
      content: '';
    }
    &::before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
    padding: 25px 15px;
    background-color: #fff;
    border-radius: 8px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #3569c0 transparent;
  }
  .legend {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: solid 1px rgb(#808080, .3);
    .content {
      display: flex;
      flex-direction: column;
    }
    .list {
      padding-block: 8px;
      display: flex;
      align-items: center;
      gap: 10px;
      border-top: solid 1px rgb(#808080, .3);
    }
    .image {
      display: flex;
      flex-direction: column;
      gap: 10px;
      figure {
        width: 30px;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
    .textarea {
      display: flex;
      flex-direction: column;
      gap: 5px;
      flex: 1;
    }
    .name {
      font-size: 14px;
      font-weight: 600;
      line-height: 1.2em;
    }
    .text {
      font-size: 12px;
      line-height: 1.5em;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
  }
  @media (any-hover: hover) {
    .search {
      .list {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
  @media screen and (min-width: 830px) {
    .inner {
      padding: 50px 30px;
    }
    .close {
      width: 25px;
      height: 25px;
      top: 15px;
      right: 30px;
      &::before,
      &::after {
        width: 35px;
        height: 4px;
      }
    }
    .card {
      width: auto;
    }
    .legend {
      .list {
        .image {
          figure {
            width: 80px;
          }
        }
      }
      .name {
        font-size: 18px;
      }
      .text {
        font-size: 15px;
      }
    }
    .title {
      font-size: 20px;
    }
  }
}
</style>
